<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="project-diagram"/>
          {{ $t('phoneNetwork') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.countryIndex" @input="load">
          <b-tab v-for="item in $store.state.countries" :key="item._id" :title="item.name"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>

      <!-- c-paging -->
      <div class="col-12">
        <div class="c-sorting" v-if="['owner', 'admin', 'tech', 'operationsManager'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
            <!-- col -->
          </div>
          <!-- row -->
        </div>
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('networkName') }}</div>
            <div class="col-lg-2">{{ $t('networkCode') }}</div>
            <div class="col-lg-3">{{ $t('numberPrefixes') }}</div>
            <div class="col-lg-2">{{ $t('info') }}</div>
            <div class="col-lg-3"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('networkName') }}: </b>
              <span>{{ item.name }}</span>
              <span><label class="badge badge-info">{{ item.country ? item.country.name : '' }}</label></span>
              <span v-if="item.default"><label class="badge badge-primary">{{ $t('default') }}</label></span>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('networkCode') }}: </b>
              <span>{{ item.code }}</span>
            </div>
            <div class="col-lg-3">
              <b class="c-smart-table__label">{{ $t('numberPrefixes') }}: </b>
              <span>{{ item.numberPrefixes ? item.numberPrefixes.join(', ') : '' }}</span>
            </div>
            <div class="col-lg-2">
              <div>
                <b>{{ $t('setupFee') }}: </b>
                <span v-if="item.setupFee">{{ item.setupFee | numFormat}}</span>
                <span v-else>--</span>
              </div>
              <div>
                <b>{{ $t('monthlyFee') }}: </b>
                <span v-if="item.monthlyFee">{{ item.monthlyFee | numFormat}}</span>
                <span v-else>--</span>
              </div>
              <div>
                <b>{{ $t('netCallFee') }}: </b>
                <span v-if="item.netCallFee">{{ item.netCallFee | numFormat}}</span>
                <span v-else>--</span>
              </div>
              <div>
                <b>{{ $t('offnetCallFee') }}: </b>
                <span v-if="item.offnetCallFee">{{ item.offnetCallFee | numFormat}}</span>
                <span v-else>--</span>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="update(item._id)" type="button" v-if="['owner', 'admin', 'tech', 'operationsManager'].includes($store.state.user.role)"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" v-if="['owner', 'admin'].includes($store.state.user.role)"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <country-select :model="formModel" :errors="formErrors"></country-select>
      <form-input :label="$t('networkName')" :model="formModel" attribute="name" :errors="formErrors">
      </form-input>
      <form-input :label="$t('networkCode')" :model="formModel" attribute="code" :errors="formErrors">
      </form-input>
      <form-array :label="$t('numberPrefixes')" :model="formModel" attribute="numberPrefixes"
                  :errors="formErrors"></form-array>
      <form-input :label="$t('setupFee')" :model="formModel" attribute="setupFee" :errors="formErrors">
      </form-input>
      <form-input :label="$t('monthlyFee')" :model="formModel" attribute="monthlyFee" :errors="formErrors">
      </form-input>
      <form-input :label="$t('netCallFee')" :model="formModel" attribute="netCallFee" :errors="formErrors">
      </form-input>
      <form-input :label="$t('offnetCallFee')" :model="formModel" attribute="offnetCallFee" :errors="formErrors">
      </form-input>
      <form-input :label="$t('minBillSecs')" :model="formModel" attribute="minBillSecs" :errors="formErrors">
      </form-input>
      <form-input :label="$t('blockBillSecs')" :model="formModel" attribute="blockBillSecs" :errors="formErrors">
      </form-input>
      <form-checkbox :chk-label="$t('default')" :model="formModel" attribute="default"
                     :errors="formErrors"></form-checkbox>
    </b-modal>
  </main>
</template>
<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import CountrySelect from "../../components/CountrySelect";

export default {
  components: {
    CountrySelect
  },
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/phone-network',
      defaultFormModel: {
        numberPrefixes: [],
        default: false,
      },
      autoLoad: true
    }
  },
  i18n: {
    messages: {
      en: {
        phoneNetwork: 'Phone network',
        networkCode: 'Network code',
        numberPrefixes: 'Number prefixes',
        networkName: 'Network name',
        setupFee: 'Setup fee',
        monthlyFee: 'Monthly fee',
        netCallFee: 'In network call fee',
        offnetCallFee: 'Off network call fee',
        minBillSecs: 'Minimum bill seconds',
        blockBillSecs: 'Block bill seconds',
        default: 'Default'
      },
      vi: {
        phoneNetwork: 'Mạng',
        networkCode: 'Mã mạng',
        numberPrefixes: 'Đầu số',
        networkName: 'Tên mạng',
        setupFee: 'Phí cài đặt',
        monthlyFee: 'Phí hàng tháng',
        netCallFee: 'Phí gọi nội mạng',
        offnetCallFee: 'Phí gọi ngoại mạng',
        minBillSecs: 'Số giây tính cước tối thiểu',
        blockBillSecs: 'Số giây / block tính cước',
        default: 'Mặc định'
      }
    }
  },
  methods: {
    getCountryId: function (index) {
      let country = this.$store.state.countries[index];
      return country ? country._id : null;
    },
    load: function () {
      this.filterFormModel.country = this.getCountryId(this.filterFormModel.countryIndex);
      let loader = this.$loading.show();
      this.$service.get(this.service, {
        params: this.filterFormModel
      }).then(response => {
        this.apply(response.data);
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
      });
    },
    create: function () {
      this.formModel = {};
      this.formModel = Object.assign({}, this.formModel, this.defaultFormModel);
      this.formModel.country = this.filterFormModel.country;
      this.formTitle = this.$t('create');
      this.formErrors = [];
      this.showForm = true;
    },
  }
}
</script>